import { http } from '@pendo/http';
import { b64EncodeUnicode } from '@utils/http';
const accountsApi = '/api/s/_SID_/account';

export function fetchAccounts (searchTerm = '') {
    const params = `?search=${encodeURIComponent(searchTerm)}`;

    return http.get(`${accountsApi}${params}`);
}

export function fetchAccountById (id) {
    const b64AccountId = `b64_${b64EncodeUnicode(id)}`;

    return http
        .get(`${accountsApi}/${b64AccountId}`, {
            headers: {
                'X-Pendo-Base64-Encoded-Params': true,
            },
        })
        .then((res) => res.data);
}

export function getAccountDetailUrl (id) {
    return `/account/${encodeURIComponent(encodeURIComponent(id))}`;
}

/**
 * Converts a dot-separated account display name (e.g. 'agent.name')
 * into a table column key (e.g. 'account_agent_name').
 */
export function getDynamicAccountKey (accountDisplayNamePath) {
    if (!accountDisplayNamePath || typeof accountDisplayNamePath !== 'string') return null;

    const parts = accountDisplayNamePath.split('.');
    if (parts.length !== 2) return null;

    return `account_${parts[0]}_${parts[1]}`;
}

export function generateAccountDescription (accountId) {
    const b64AccountId = `b64_${b64EncodeUnicode(accountId)}`;

    return http
        .post(`${accountsApi}/${b64AccountId}/generatedescription`, {}, {
            headers: {
                'X-Pendo-Base64-Encoded-Params': true,
            },
        })
        .then((res) => res.data);
}
